import { prevArrow, nextArrow, options } from "@/global/slick-options";

const sliders = document.querySelectorAll( '.icons-slider' );

sliders.forEach( slider => {
    jQuery( slider ).slick( {
        ...options,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    } );

} );
